import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import Message from 'owa-service/lib/contract/Message';

const isMessageUnathenticated = (message: Message) =>
    message.AntispamUnauthenticatedSender ||
    folderNameToId('junkemail') === message.ParentFolderId.Id;

export default isMessageUnathenticated;
